// @owners { team: patients }
import { Link } from '@alto/design-system';
import { useNavigation } from '@alto/navigation';
import React from 'react';
import { useAnalytics } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { type ORIGIN_NAMES } from '~shared/lib/analytics/src/getOrigin';

type Props = {
  readonly prescriptionID: number;
  readonly origin: (typeof ORIGIN_NAMES)[keyof typeof ORIGIN_NAMES];
};

export const QuantityChangeLink = ({ prescriptionID, origin }: Props) => {
  const { trackEvent } = useAnalytics();
  const { navigate } = useNavigation();

  const onPress = () => {
    trackEvent({
      event: EVENTS.QUANTITY_CHANGE_INITIATED,
      params: { origin },
      additionalFields: { prescriptionId: prescriptionID },
    });
    navigate('RouteChangeQuantity', { prescriptionID });
  };

  return (
    <Link
      textSize="mini"
      fontFamily="regular"
      onPress={onPress}
    >
      Change
    </Link>
  );
};
